export const stripToDigits = (value: string) => value.replace(/\D/g, '')

export const formatPhoneDisplay = (phone?: string): string => {
  if (!phone) return ''

  const cleaned = phone.replace(/\D/g, '')
  const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/)

  if (!match) return ''

  const [, first, second, third] = match

  if (!second) return first
  if (!third) return `(${first}) ${second}`
  return `(${first}) ${second}-${third}`
}
